<template>
  <!-- 【废弃】 -->
  <div>
    <!-- <button style="width:100px;height:50px" @click="test"></button> -->
    <!-- 编辑器 加载动画 :value="content" :content="content"  -->
    <el-row v-loading="quillUpdateImg">
      <!-- 原生编辑器:value="introduce" -->
      <!-- <div>{{introduce}}</div> -->
      <quill-editor class="quill-editor-v1"
                    v-model="introduce"
                    @input="modelContent"
                    ref="myQuillEditor"
                    :options="editorOption"></quill-editor>
    </el-row>
    <!-- element的上传文件按钮 -->
    <el-upload class="editor-image"
               :action="$ip + '/add_image?key_name=editor_v1_image'"
               :with-credentials="true"
               name="image"
               :show-file-list="false"
               :multiple="true"
               accept=".jpg, .jpeg, .png, .gif"
               :before-upload="beforeUpload"
               :on-success="uploadSuccess"
               :on-error="uploadError"></el-upload>
  </div>
</template>

<script>
// 修改 对其方式 ，quill 提供三种对其方式：1，style 2.class 3.ql-class
let Align = Quill.import('attributors/style/align')
Align.whitelist = ['right', 'center', 'justify']
Quill.register(Align, true)

let Size = Quill.import('attributors/style/size')
Size.whitelist = [
  '9px',
  '10px',
  false,
  '12px',
  '13px',
  '14px',
  '15px',
  '16px',
  '17px',
  '18px',
  '19px',
  '20px',
]
Quill.register(Size, true)
// 配置工具栏
const toolbarOptions = [
  [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
  [{ font: [] }], // 字体类型
  ['emoji'],
  ['bold', 'italic', 'underline', 'strike'], // 字体粗细:加粗，斜体，下划线，横线
  ['blockquote'], // 引用，代码 ： "code-block"
  [{ header: 1 }, { header: 2 }], // 标题1 标题2
  //[{ header: [1, 2, 3, 4, 5, 6, false] }], // 多级标题
  [{ list: 'ordered' }, { list: 'bullet' }], // 列表
  // [{ script: "sub" }, { script: "super" }], // 上角标，下角标
  [{ indent: '-1' }, { indent: '+1' }], // 缩进
  //[{ direction: "rtl" }], // text direction

  [{ color: [] }, { background: [] }], // 颜色和 背景色

  [{ align: [] }], // 剧中，左对齐，有对齐
  ['link', 'image', 'video'], // 链接、
  ['clean'], // 清除样式
]
export default {
  name: 'editor',
  data() {
    return {
      quillUpdateImg: false,
      //serverUrl: "$ip", //要上传的图片服务器地址,华东，查看上传地址：https://developer.qiniu.com/kodo/manual/1671/region-endpoint
      //   content: "", // 富文本内容http://121.196.53.21:8081/add_image
      introduce: this.editor_content, // 输入框
      // 编辑器
      editorOption: {
        // 编辑器可选项：覆盖编辑器的 配置项，绑定编辑器的options
        placeholder: '', //
        theme: 'snow', //"snow" or 'bubble' 主题

        modules: {
          'emoji-toolbar': true,
          'emoji-shortname': true,
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              emoji: function () {},
              image: function (value) {
                if (value) {
                  document.querySelector('.editor-image input').click()
                } else {
                  this.quill.format('image', false)
                }
              },
            },
          },
        },
      },
    }
  },
  props: { editor_content: String },
  mounted() {
    // 监听 ctrl+v 键盘事件

    document.addEventListener('paste', (event) => {
      console.log('sssss1' + event.clipboardData)

      const isImage =
        event.clipboardData.types.length &&
        event.clipboardData.types.join('').includes('Files')
      console.log('判断是否是图片：' + isImage)
      if (!isImage) {
        return
      }

      const file = event.clipboardData.files[0]
      console.log('图片：' + file.name)
      if (
        !file ||
        !file.name ||
        !(
          file.name.toLowerCase().indexOf('.png') !== -1 ||
          file.name.toLowerCase().indexOf('.gif') !== -1 ||
          file.name.toLowerCase().indexOf('.jpg') !== -1 ||
          file.name.toLowerCase().indexOf('.jpeg') !== -1
        )
      ) {
        console.log('粘贴的不是图片')
        return
      }

      var formData = new FormData()
      formData.append('file', file)
    })
  },
  methods: {
    modelContent(content) {
      // console.log("文本框有变化");
      // console.log(this.introduce);
      // console.log('mode' + content)

      this.$emit('content_change', content)
      // this.introduce = event.traget.value;
    },
    onEditorBlur() {
      // 失去焦点事件
    },
    onEditorFocus() {
      // 获得焦点事件
    },
    onEditorChange() {
      // 内容改变事件
      console.log('内容改变了')
    },
    // 提交图文
    submitIntroHeader() {
      if (this.introduce == '') {
        this.$message.error('提交的内容不能为空')
      } else {
        this.$http
          .post('/company-info', { header_introduce: this.introduce })
          .then((res) => {
            const { errmsg, errno } = res.data
            if (errno == '0') {
              this.$notify({
                title: '成功',
                message: '确认单头部' + errmsg,
                type: 'success',
              })
            }
          })
      }
    },

    beforeUpload(file) {
      this.quillUpdateImg = true
      const isFORMAT =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/gif'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isFORMAT) {
        this.$message.error('上传头像图片只能是 JPG/png/gif 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      //   console.log(file);
      return isFORMAT && isLt2M
    },

    // 上传图片方法: 上传成功后，返回链接给编辑器。
    uploadSuccess(res, file) {
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      // console.log(res);
      // 检查是否
      if (res.errno == '4101') {
        this.$notify({
          title: '警告',
          message: res.errmsg,
          type: 'warning',
        })
        this.quillUpdateImg = false
        return
      }

      const { image_url, errmsg, errno } = res.data
      let quill = this.$refs.myQuillEditor.quill
      //   如果上传成功 {data: {…}, errmsg: "保存图片信息成功", errno: "0"}
      if (res.errno === '0' && res.msg !== '保存图片信息成功') {
        // 获取光标所在位置,quill api
        let length = quill.getSelection().index
        // 插入图片  res.info为服务器返回的图片地址 ,quill api
        //quill.insertEmbed() 向编辑器中插入嵌入式内容，返回一个改变后的Delta对象。
        //insertEmbed(index: Number, type: String, value: any, source: String = 'api'): Delta
        // index: Number：插入的位置， type: String：插入的类型， value: any：插入的值
        quill.insertEmbed(length, 'image', image_url)
        // 调整光标到最后一位
        quill.setSelection(length + 1)
      } else {
        this.$message.error('图片插入失败')
      }
      // loading动画消失
      this.quillUpdateImg = false
    },

    uploadError(res) {
      this.quillUpdateImg = false
      console.log(res)
      this.$message.error('图片插入失败')
    },
  },
}
</script>

<style>
</style>